import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import {
    CoachingTranscript,
    TranscriptFocus,
} from '../../../coaching-base/general';
import { TranscriptService as CoachingTranscriptService } from '../../../coaching-base/transcript.service';
import { Dependencies } from '../../../store';
import { pluck } from '../../../store.decorator';
import { PayloadAction } from '../../../store.model';
import { Transcript, TranscriptService } from '../../../teams-call';
import { ApiService } from '../../coach-assist';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import {
    UpdateTranscript,
    updateTranscriptResult,
} from './update-transcript.action';

export const updateTranscriptEpic = (
    action: ActionsObservable<PayloadAction<ActionType, UpdateTranscript>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<ActionType> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT),
        mergeMap((act: PayloadAction<ActionType, UpdateTranscript>) => {
            const rootState = pluck<TranscriptDialogState>(
                state.value,
                act.storePath,
            );
            const tsService =
                deps.injector.get<TranscriptService>(TranscriptService);
            const ctsService = deps.injector.get<CoachingTranscriptService>(
                CoachingTranscriptService,
            );
            const caService = deps.injector.get<ApiService>(ApiService);

            const obses: [
                Observable<Transcript>,
                Observable<TranscriptFocus[]>,
                Observable<boolean>,
            ] = [
                act.payload.transcript.name !== rootState.transcript.name ||
                act.payload.transcript.description !==
                    rootState.transcript.description
                    ? tsService.update(act.payload.transcript)
                    : of(rootState.transcript),
                act.payload.transcript.focuses !== rootState.transcript.focuses
                    ? ctsService.updateFocuses(
                          act.payload.transcript.transcriptId,
                          act.payload.transcript.focuses,
                      )
                    : of(rootState.transcript.focuses),
                act.payload.transcript.summary !== rootState.transcript.summary
                    ? caService.updateCaSummary(
                          act.payload.transcript.transcriptId,
                          act.payload.transcript.summary,
                      )
                    : of(true),
            ];

            return forkJoin(obses).pipe(
                map((ret) => {
                    (ret[0] as CoachingTranscript).focuses = ret[1];
                    return ret[0];
                }),
                map((ret) => {
                    return updateTranscriptResult(
                        {
                            ...act.payload,
                            transcript: ret,
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
